
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funds/[slug]",
      function () {
        return require("private-next-pages/funds/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funds/[slug]"])
      });
    }
  